import { gql } from "@apollo/client";

export const GET_LOGIN_LOGS = gql`
  query GetLoginLogs($filters: LoginLogFiltersTypeInput, $pageRequest: PageRequestTypeInput) {
    getLoginLogs(filters: $filters, pageRequest: $pageRequest) {
      content {
        id
        accountId
        phone
        operationType
        clientType
        clientIp
        userAgent
        appVersion
        loginResult
        failureReason
        createdBy
        createdAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export interface LoginLogType {
  id: number;
  accountId: number | null;
  phone: string | null;
  operationType: string;
  clientType: string;
  clientIp: string | null;
  userAgent: string | null;
  appVersion: string | null;
  loginResult: string;
  failureReason: string | null;
  createdBy: string | null;
  createdAt: number | null;
}

export interface GetLoginLogsResponse {
  getLoginLogs: {
    content: LoginLogType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
  };
}
